import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';

const MUTATION = gql`
  mutation ExtractAnnotationsFromUrl(
    $projectId: ID!
    $generationTool: GenerationToolEnum!
    $briefType: String!
    $urlType: ExtractAnnotationsUrlTypeEnum!
    $url: String!
    $subject: String
  ) {
    extractAnnotationsFromUrl(
      projectId: $projectId
      generationTool: $generationTool
      briefType: $briefType
      urlType: $urlType
      url: $url
      subject: $subject
    ) {
      id
    }
  }
`;

export const extractAnnotationsFromUrl = async ({
  projectId,
  generationTool,
  briefType,
  urlType,
  url,
  subject,
}) => {
  const variables = { projectId, generationTool, briefType, urlType, url, subject };
  const mutateOptions = {
    mutation: MUTATION,
    variables,
  };

  const result = await executeGqlMutation(mutateOptions);
  return getSingleProp(result.data);
};
